import { SparkleContext } from "../context";
import React from "react";
export const ImageWrapper = React.forwardRef((props, ref) => {
    const { components } = React.useContext(SparkleContext);
    const Image = components.image;
    if (Image) {
        return React.createElement(Image, { ref: ref, ...props });
    }
    return React.createElement("img", { ref: ref, ...props });
});
//# sourceMappingURL=ImageWrapper.js.map